import { updateTimeAssignment } from "@/api/timeAssignments/updateTimeAssignment";
import { useMutation } from "@tanstack/react-query";

export const useUpdateTimeAssignment = () => {
  return useMutation({
    mutationKey: ["updateTimeAssignment"],
    mutationFn: updateTimeAssignment,
  });
};